import { useEffect } from 'react';
import { resolveLegacyHostRedirect } from '../config/legacyHostRedirect';
import LoadingScreen from './LoadingScreen';

/** Full-page redirect off legacy combined hosts before the SPA mounts routes. */
export default function LegacyHostRedirect({ children }) {
  const { hostname, pathname, search, hash } = window.location;
  const target = resolveLegacyHostRedirect(hostname, pathname, search, hash);

  useEffect(() => {
    if (target) {
      window.location.replace(target);
    }
  }, [target]);

  if (target) {
    return <LoadingScreen label="Redirecting to RS Works…" />;
  }

  return children;
}
